import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { HowItWorksComponent } from './how-it-works.component';
import { LandingSharedModule } from '../landing-shared/landing-shared.module';
import { CardSectionComponent } from './cards/cards.component';
import { WhatDescriptionComponent } from './what-description/what-description.component';


@NgModule({
  declarations: [
    HowItWorksComponent,
    CardSectionComponent,
    WhatDescriptionComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    SharedModule,
    LandingSharedModule,
    RouterModule,
  ],
  providers: [],
})
export class HowItWorksModule {}
